import { render, staticRenderFns } from "./ConsolidationUnionEditLabelAdmin.vue?vue&type=template&id=12351d49&scoped=true"
import script from "./ConsolidationUnionEditLabelAdmin.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionEditLabelAdmin.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationUnionEditLabelAdmin.vue?vue&type=style&index=0&id=12351d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12351d49",
  null
  
)

export default component.exports